/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Ext_Device_PromptInputs */

const en_creator_ext_device_prompt = /** @type {(inputs: Creator_Ext_Device_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Would you like to enable external device control (such as foot pedal)?`)
};

const fr_creator_ext_device_prompt = /** @type {(inputs: Creator_Ext_Device_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Souhaitez-vous activer le controle d'un appareil externe (comme une pedale) ?`)
};

const de_creator_ext_device_prompt = /** @type {(inputs: Creator_Ext_Device_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchten Sie die Steuerung durch externe Geräte (z. B. ein Fußpedal) aktivieren?`)
};

const it_creator_ext_device_prompt = /** @type {(inputs: Creator_Ext_Device_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desideri abilitare il controllo di un dispositivo esterno (ad esempio un pedale)?`)
};

const ru_creator_ext_device_prompt = /** @type {(inputs: Creator_Ext_Device_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хотите включить управление внешними устройствами (например, ножной педалью)?`)
};

const es_creator_ext_device_prompt = /** @type {(inputs: Creator_Ext_Device_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Quieres habilitar el control de dispositivos externos (como el pedal)?`)
};

const zh_cn2_creator_ext_device_prompt = /** @type {(inputs: Creator_Ext_Device_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您是否希望启用外部设备控制（例如脚踏板）？`)
};

const ja_creator_ext_device_prompt = /** @type {(inputs: Creator_Ext_Device_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外部デバイスコントロール（フットペダルなど）を有効にしますか?`)
};

const hi_creator_ext_device_prompt = /** @type {(inputs: Creator_Ext_Device_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या आप बाहरी उपकरण नियंत्रण (जैसे कि फुट पेडल) को सक्षम करना चाहेंगे?`)
};

const pt_pt2_creator_ext_device_prompt = /** @type {(inputs: Creator_Ext_Device_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deseja ativar o controle por dispositivo externo (como um pedal)?`)
};

/**
* | output |
* | --- |
* | "Would you like to enable external device control (such as foot pedal)?" |
*
* @param {Creator_Ext_Device_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_ext_device_prompt = /** @type {((inputs?: Creator_Ext_Device_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Ext_Device_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_creator_ext_device_prompt(inputs)
	if (locale === "de") return de_creator_ext_device_prompt(inputs)
	if (locale === "it") return it_creator_ext_device_prompt(inputs)
	if (locale === "ru") return ru_creator_ext_device_prompt(inputs)
	if (locale === "es") return es_creator_ext_device_prompt(inputs)
	if (locale === "zh-CN") return zh_cn2_creator_ext_device_prompt(inputs)
	if (locale === "ja") return ja_creator_ext_device_prompt(inputs)
	if (locale === "hi") return hi_creator_ext_device_prompt(inputs)
	if (locale === "pt-PT") return pt_pt2_creator_ext_device_prompt(inputs)
	return en_creator_ext_device_prompt(inputs)
});